module.exports = __webpack_public_path__ + "img/no-inventory-outage.2112ad22.svg";